package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.selection.selectableGroup
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.LocalMinimumInteractiveComponentSize
import androidx.compose.material3.LocalRippleConfiguration
import androidx.compose.material3.RadioButton
import androidx.compose.material3.RadioButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import com.example.mystybag.common.model.RadioButtonOption
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p0
import com.example.mystybag.core.views.AppTheme


@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RadioButtonGroup(modifier: Modifier = Modifier, options: List<RadioButtonOption>, onItemSelected: (id: Int) -> Unit) {
    Column(
        modifier            = modifier.selectableGroup(),
        verticalArrangement = Arrangement.spacedBy(p16)
    ) {
        CompositionLocalProvider(LocalRippleConfiguration provides null) {
            options.forEachIndexed { _, option ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .selectable(
                            selected = option.isSelected,
                            onClick = {
                                onItemSelected(option.id)
                            },
                            role = Role.RadioButton
                        )
                        .padding(bottom = p12),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    CompositionLocalProvider(LocalMinimumInteractiveComponentSize provides p0) {
                        RadioButton(
                            modifier = Modifier.padding(end = p16),
                            selected = option.isSelected,
                            onClick = {
                                onItemSelected(option.id)
                            },
                            colors = RadioButtonDefaults.colors(
                                selectedColor   = AppTheme.current.colors.primary,
                                unselectedColor = AppTheme.current.colors.outline
                            )
                        )
                        Texts.BodyLarge(text = option.text, fontWeight = FontWeight.Medium.takeIf { option.isBold })
                    }
                }
            }
        }
    }
}